type TimestampLike = {
  toDate?: unknown;
  toMillis?: unknown;
};

function dateFromValue(value: unknown) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value : null;
  }

  if (typeof value === 'number' || typeof value === 'string') {
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? date : null;
  }

  if (typeof value !== 'object') {
    return null;
  }

  const timestamp = value as TimestampLike;

  if (typeof timestamp.toDate === 'function') {
    try {
      const date = timestamp.toDate();
      return date instanceof Date && Number.isFinite(date.getTime())
        ? date
        : null;
    } catch {
      return null;
    }
  }

  if (typeof timestamp.toMillis === 'function') {
    try {
      const date = new Date(timestamp.toMillis());
      return Number.isFinite(date.getTime()) ? date : null;
    } catch {
      return null;
    }
  }

  return null;
}

export function formatNotificationAge(value: unknown, now = Date.now()) {
  const date = dateFromValue(value);

  if (!date) {
    return '';
  }

  const elapsedMs = Math.max(0, now - date.getTime());

  if (elapsedMs < 60_000) {
    return 'now';
  }

  const minutes = Math.floor(elapsedMs / 60_000);

  if (minutes < 60) {
    return `${minutes}m ago`;
  }

  const hours = Math.floor(minutes / 60);

  if (hours < 24) {
    return `${hours}h ago`;
  }

  const days = Math.floor(hours / 24);

  if (days < 7) {
    return `${days}d ago`;
  }

  const weeks = Math.floor(days / 7);

  if (weeks < 5) {
    return `${weeks}w ago`;
  }

  const months = Math.max(1, Math.floor(days / 30));

  if (days < 365) {
    return `${months}mo ago`;
  }

  return `${Math.floor(days / 365)}y ago`;
}
